import React from "react";
import { Loader2 } from "lucide-react";

const LoadingSpinner = ({ message = "جاري التحميل..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 gap-3">
      <Loader2 className="w-8 h-8 text-yellow-500 animate-spin" />
      <span className="text-gray-400 text-sm">{message}</span>
    </div>
  );
};

export default LoadingSpinner;